// extracted by mini-css-extract-plugin
export var formContainer = "_ju-0";
export var message = "_ju-1";